module.exports = __webpack_public_path__ + "static/customer-notification-0a11db3a0d86ec28c310c7a0d7ff87f2.png";